"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isListener_1 = require("./isListener");
exports.default = (function (models) {
    return Object.keys(models).reduce(function (actionCreators, modelName) {
        var _a = models[modelName].reducers, reducers = _a === void 0 ? {} : _a;
        Object.keys(reducers)
            .filter(function (reducerName) { return !isListener_1.default(reducerName); })
            .forEach(function (reducerName) {
            var type = modelName + "/" + reducerName;
            actionCreators[type] = function (payload, meta) { return ({
                type: type, payload: payload, meta: meta,
            }); };
        });
        return actionCreators;
    }, {});
});
//# sourceMappingURL=getActionCreators.js.map